import { render, staticRenderFns } from "./bon-consultation.html?vue&type=template&id=18f05742&scoped=true&external"
import script from "./bon-consultation.js?vue&type=script&lang=js&external"
export * from "./bon-consultation.js?vue&type=script&lang=js&external"
import style0 from "./bon-consultation.scss?vue&type=style&index=0&id=18f05742&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f05742",
  null
  
)

export default component.exports